class JsonHelper {
  static getJsonMessage(...args) {
    return JSON.stringify(Object.assign.apply(undefined, [{}].concat(args)));
  }
}

export default JsonHelper;
